// extracted by mini-css-extract-plugin
export default {"icon":"glCNCo2mAvg0iE0Ez3ie","background":"B_EXsz_crb9vFqHeJ7ht","image":"lfFfy6O9Xp6ilqN5eec_","button":"L0hycjgXKQwKhT24StqS"};